import React from 'react'

const Privacy=()=>{
    return(
        <div dangerouslySetInnerHTML={{__html:`<p>Privacy Policy</p>

        <p>Last updated: 1st April 2021</p>
        
        <p> </p>
        
        <p>We (Fizz &amp; Fexy Media., or &ldquo;Talentino&rdquo;) are deeply concerned about your privacy and we take this concern very seriously. This Privacy Policy (&ldquo;Privacy Policy&rdquo;) sets out how we collect, process, use and may disclose your data when you use our mobile application called &lsquo;Talentino&rsquo; (&ldquo;App&rdquo;). The App is referred to as the &ldquo;Platform&rdquo;. References to &ldquo;we&rdquo;, &ldquo;our&rdquo; or &ldquo;us&rdquo; or the &ldquo;Company&rdquo; shall mean the Platform and/or Fizz &amp; Fexy Media. Any references to &ldquo;you&rdquo;, &ldquo;your&rdquo; or &ldquo;user&rdquo; shall mean any person or entity using our Platform. We will not use or share your information with anyone except as described in this Privacy Policy.</p>
        
        <p></p>
        
        <p>This Privacy Policy is a part of and is to be read with the Talentino Terms of Use (&ldquo;Terms&rdquo;). By using this Platform, you agree to the terms and conditions of this Privacy Policy. You also consent to our use and disclosure of your Personal Information (as defined below) in the manner described in this Privacy Policy. The capitalized words used in this Privacy Policy but not defined herein, shall have the meaning given to such words in the Terms. If you do not agree with the terms and conditions of this Privacy Policy, please do not use this Platform.</p>
        
        <p></p>
        
        <p>THE INFORMATION WE COLLECT AND HOW WE USE IT</p>
        
        <p></p>
        
        <p>The following table lists the information we collect from you and how we use it:</p>
        
        <p> Information We Collect</p>
        
        <p>How We Use It</p>
        
        <p>(a) Log-in Data: User ID, mobile phone number, email ID, gender (optional), and IP address. We may collect an indicative age range which tells us that you are of the appropriate age to access our Platform and certain features of our Platform (collectively &ldquo;Log-in Data&rdquo;).</p>
        
        <p>Content You Share: This comprises of all the information you make available to other users via the Platform, such as:</p>
        
        <p></p>
        
        <p>&middot; Information about you or relating to you that is voluntarily shared by you on the Platform, including without limitation, any quotes, images, political opinions, religious views, profile photo, user bio and handle, inter alia.</p>
        
        <p></p>
        
        <p>&middot; Any posts that you make on the Platform.</p>
        
        <p>&middot; To set up and facilitate log-in to a user account on Platform;</p>
        
        <p>&middot; To notify you about changes to the Platform, including this Privacy Policy;</p>
        
        <p>&middot; To facilitate communication, including provision of user support;</p>
        
        <p>&middot; To enforce our terms, conditions, and policies and any of our rights, or the rights of our affiliate companies, or other users of the Platform;</p>
        
        <p></p>
        
        <p>&middot; To develop new services and improve the existing services and the Platform and integrate user feedback and requests;</p>
        
        <p></p>
        
        <p>&middot; To provide language and location based personalization;</p>
        
        <p></p>
        
        <p>&middot; To administer the Platform and for internal operations, including troubleshooting, data analysis, testing, research, security, fraud-detection, account management, and survey purposes;</p>
        
        <p></p>
        
        <p>&middot; To better understand how you use and access the Platform and to improve the user experience on the Platform;</p>
        
        <p></p>
        
        <p>&middot; To pseudonymised and aggregate your information, including Personal Information, for conducting user demographic analysis on items such as region, phone model, operating system platform, system language, and the Platform version in order to better understand how our users are using the Platform;</p>
        
        <p>&middot; To pseudonymised and aggregate your information, including Personal Information, for collection of web and account traffic statistics of what content and services are used when users access third-party services on the Platform;</p>
        
        <p>&middot; To upload or create replicable profiles on associated/ sister platforms;</p>
        
        <p></p>
        
        <p>&middot;To assess effectiveness of and improve advertising and other marketing and promotional activities.</p>
        
        <p></p>
        
        <p>Information we receive from other sources: . We may also be working closely with third parties (including, for example, business partners, sub-contractors in technical, analytics providers, search information providers) and may receive information about you from such sources. Such data may be shared internally and combined with the data collected on this Platform.</p>
        
        <p>(b) Log Data: &quot;Log Data&quot; is information that we automatically collect when you use the Platform, whether through the use of cookies, web beacons, log files, scripts, including, but not limited to:</p>
        
        <p></p>
        
        <p>&middot; technical information, such as your mobile carrier-related information, configuration information made available by your web browser or other programs you use to access the Platform, your IP address and your device&rsquo;s version and identification number;</p>
        
        <p>&middot; information about what you have searched for and viewed while using the Platform, such as web search terms used, social media profiles visited, mini applications used, and details of other information and content accessed or requested by you while using the Platform;</p>
        
        <p>&middot; general information about communications on the platform, such as the identity of a user that you have communicated with and the time, data and duration of your communications; and</p>
        
        <p></p>
        
        <p>&middot; metadata, which means information related to items you have made available through the Platform, such as the date, time or location that a shared photograph or video was taken or posted.</p>
        
        <p>(c) Cookies: Our Platform uses cookies to distinguish you from other users of our Platform. This helps us to provide you with a good user experience when you browse our Platform and allows us to improve the Platform. We collect the cookie data from the cookies on your device. For detailed information on the cookies we use and the purposes for which we use them, kindly see our cookie policy</p>
        
        <p>(d) Surveys: If you choose to participate in a survey, we may request you to provide certain Personal Information i.e. any information that could be used to identify you (&ldquo;Personal Information&rdquo;). We may use a third-party service provider to conduct these surveys and this will be notified to you prior to the completion of the survey.</p>
        
        <p>(e) User Search Data: Any searches that are conducted by you on the Platform.</p>
        
        <p>To provide you quick access to your previous searches. To use analytics for personalization and to show you targeted advertisements.</p>
        
        <p>(f) Additional Account Security: We collect your phone number and request access to the SMSes on your phone by sending you a One-Time-Password (&ldquo;OTP&rdquo;), which you confirm by entering the OTP to verify your identity, while registering with our Platform.</p>
        
        <p>To verify your identity and for maintaining your account security. We request access to your SMS folder to automatically read the OTP generated.</p>
        
        <p>(g) Contacts List: We access the contacts list on your mobile device. We always ask for your consent before accessing your contacts list and you have the option to deny us the access to your contacts list.</p>
        
        <p> To provide suggestions and invite your friends and other contacts to the platform and to notify you when any individual joins the platform.</p>
        
        <p>(h) Location Information: &quot;Location Data&quot; is information that is derived from your GPS, IP address, and/or public posts that contain location information.</p>
        
        <p></p>
        
        <p>You will disclose certain location information to us and to other Platform users when you access the Platform, as we derive location information from your IP address, device, or internet service for providing the Services or improving our platform such as to ensure that there are no multiple log-ins on your account.</p>
        
        <p>&middot; For security, fraud-detection and account management;</p>
        
        <p></p>
        
        <p>&middot; To be used for enhanced content targeting;</p>
        
        <p></p>
        
        <p>&middot; To provide you with location-based services that you choose to use:</p>
        
        <p></p>
        
        <p>&sect; mini applications that may be made available on the Platform from time to time, which may require such information based on the services that they provide (if you choose to disclose your location to any mini application);</p>
        
        <p>&sect; To provide language and location customisation.</p>
        
        <p>(i) Customer Support Information: Any information that you provide to our customer support team regarding any assistance or support that you may require for using our Platform from time to time.</p>
        
        <p>To help provide you support and assistance</p>
        
        <p>(j) Device Data: &ldquo;Device Data&rdquo; includes without limitation, the following:</p>
        
        <p></p>
        
        <p>&sect; Device attributes: information such as the operating system, operating system version and language, hardware and software versions, device company and model, screen resolution, battery level, signal strength, device RAM, device bitrate, available storage space, information pertaining to the device CPU, browser type, app and file names and types, and plugins.</p>
        
        <p></p>
        
        <p>&sect; Device operations: information about operations and behaviours performed on the device, such as whether a window is foreground or background.</p>
        
        <p></p>
        
        <p>&sect; Identifiers: unique identifiers, device IDs, ad IDs, and other identifiers, such as from games, apps or accounts you use.</p>
        
        <p></p>
        
        <p>&sect; Device signals: we may collect your Bluetooth signals, and information about nearby Wi-Fi access points, beacons, and cell towers.</p>
        
        <p></p>
        
        <p>&sect; Data from device settings: information you allow us to receive through device settings you turn on, such as access to your GPS location, camera or photos.</p>
        
        <p></p>
        
        <p>&sect; Network and connections: information such as the name of your mobile operator or ISP, network type and speed, data consumption, language, time zone, mobile phone number, IP address and connection speed.</p>
        
        <p></p>
        
        <p>&sect; Application and application version: any mobile applications that are stored on your mobile device.</p>
        
        <p></p>
        
        <p>&sect; Media: we access the media gallery on your mobile device, including without limitation, images, videos and audio files and the storage space on your phone. However, we shall always obtain your consent before accessing your images and you shall have the option to deny us such access.</p>
        
        <p> We may also use information from Apple's TrueDepth camera to improve the quality of lenses. Information from the TrueDepth camera is used in real time and we do not store this information on our servers. This information is not shared with third parties.</p>
        
        <p>&middot; To facilitate the sharing of any videos and images using the Platform;</p>
        
        <p></p>
        
        <p>&middot; To customise our Platform to suit your mobile device;</p>
        
        <p></p>
        
        <p>&middot; For purposes of camera configurations;</p>
        
        <p></p>
        
        <p>&middot; Understand whether there is enough storage space on your device to be able to download any content from the Platform for the purposes of sharing via WhatsApp and/or Facebook;</p>
        
        <p></p>
        
        <p>&middot; To optimise your user experience on our Platform;</p>
        
        <p></p>
        
        <p>&middot; To deliver optimal user video experience;</p>
        
        <p></p>
        
        <p>&middot; To verify your identity so as to enforce our terms, conditions, and policies;</p>
        
        <p></p>
        
        <p>&middot; To improve the Platform.</p>
        
        <p></p>
        
        <p></p>
        
        <p>&middot;To be used for purposes of location feed;</p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p>&middot; To derive user language/personalisation;</p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p>&middot; To facilitate the sharing of any content on the Platform via the applications downloaded on your mobile device;</p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p></p>
        
        <p>&middot; To improve the quality of camera lenses</p>
        
        <p></p>
        
        <p>DISCLOSURE OF YOUR INFORMATION</p>
        
        <p></p>
        
        <p>We disclose your information in the following manner:</p>
        
        <p> Content Visible to Others</p>
        
        <p></p>
        
        <p>Public Content i.e., any content you post on your user profile or on another user&rsquo;s profile, such as a post comment is accessible to everyone, including search engines. Any information you voluntarily disclose for posting to the Platform, including your profile page information, is accessible to anyone. When you submit, post or share the content that you choose to make public on the Platform, it may be re-shared by others. You should consider who you choose to share it with, because people who can see your activity on our Platform can choose to share it with others on and off our Platform, including people outside the audience you shared it with.</p>
        
        <p> Users can also use our Platform to create and share content about you with the audience that they choose, such as posting a photo of you or tagging you in any of their posts. We reserve the right to share all public content on any social media site or any other online or offline platform. We will never rent or sell your Personal Information to third parties, except on an anonymized basis, unless expressly provided in this Privacy Policy.</p>
        
        <p> Sharing with our Group of Companies</p>
        
        <p></p>
        
        <p>We may share your Personal Information with any member of our Group. The term &ldquo;Group&rdquo; shall mean any entity that is controlled by us, or any entity that is in control of us, or any entity that is under common control with us, whether directly or indirectly.</p>
        
        <p> What you Share with Others</p>
        
        <p></p>
        
        <p>When you share content and communicate using our Platform, you choose the audience who can view such content. For example, when you post any content from our Platform on Facebook, you select the audience for the post, such as a friend, a group of friends or all of your friends. Similarly, when you use WhatsApp or any other application on your mobile device to share the content on our Platform, you choose who you share the content with. We do not control and shall not be liable for the manner, in which such persons (with whom you choose to share content via any sharing options, such as WhatsApp or Facebook, available on the Platform) use the information that you share with them.</p>
        
        <p> Sharing with Third Parties</p>
        
        <p></p>
        
        <p>We may share your information (including Personal Information) with select third parties including:</p>
        
        <p></p>
        
        <p>- Business partners, suppliers and subcontractors (&ldquo;Affiliates&rdquo;). Affiliates may use this information to help provide, understand, and improve the Service and Affiliates&rsquo; own services for the performance of any contract that we enter into with you.</p>
        
        <p></p>
        
        <p>- Advertisers and advertising networks that require the data to select and serve relevant adverts to you and others. We do not disclose information about identifiable individuals to our advertisers, but we may provide them with aggregate information about our users (for example, we may inform them that any given number of women in a specified age group clicked on their advertisement on any given day). We may also use such aggregate information to help advertisers reach the kind of audience they want to target.</p>
        
        <p></p>
        
        <p>- Government bodies or law enforcement agencies, if we have good-faith belief that it is reasonably necessary to share your personal data or information in order to comply with any legal obligation or any government request; or to protect the rights or prevent any harm to the property, or safety of the Company, our customers, or public; or to detect, prevent or otherwise address public safety, fraud, security or technical issues.</p>
        
        <p> We may also disclose your information (including Personal Information) to select third parties in the following circumstances:</p>
        
        <p></p>
        
        <p>- If the Company or substantially all of its assets are acquired by a third party, in which case personal data held by it about its customers will be one of the transferred assets. If we are involved in a merger, acquisition, bankruptcy, reorganization, or sale of assets such that your information would be transferred or become subject to a different Privacy Policy, we will notify you in advance so you can opt out of any such new policy by deleting your account before transfer.</p>
        
        <p></p>
        
        <p> - In order to enforce or apply our Terms [https://Talentino.live/terms.html] and/or any other agreements.</p>
        
        <p></p>
        
        <p>SECURITY PRACTICES</p>
        
        <p> We have in place appropriate technical and security measures to secure the information collected by us. Where we have given you (or where you have chosen) a username which enables you to access the Platform, you are responsible for keeping these details confidential. We ask you not to share your password with anyone.</p>
        
        <p> WHERE WE STORE YOUR PERSONAL INFORMATION</p>
        
        <p></p>
        
        <p>We store your data with Amazon Web Services cloud platform provided by Amazon Web Services, Inc. (headquartered at 410 Terry Ave. N Seattle, Washington 98109, USA) and also on Google Cloud Platform provided by Google LLC (headquartered at 1101 S Flower St, Burbank, California 91502, USA) on their servers located in India and abroad. Both Amazon Web Services and Google Cloud Platform implement security measures to protect the loss, misuse and alteration of the information, details of which are available at https://aws.amazon.com/ and https://cloud.google.com. The privacy policies adopted by Amazon Web Services and Google Cloud Platform are available at https://aws.amazon.com/privacy/?nc1=f_pr and https://policies.google.com/privacy.</p>
        
        <p></p>
        
        <p>CHANGES TO THIS POLICY</p>
        
        <p></p>
        
        <p>The Company may periodically update this Privacy Policy. Whenever we make any changes to this Privacy Policy that are important for you to know about, we will post the updated Privacy Policy at this link.</p>
        
        <p></p>
        
        <p>DISCLAIMER</p>
        
        <p></p>
        
        <p>Unfortunately, the transmission of information via the internet may not always be completely secure. Although we will do our best to protect your Personal Information, we cannot guarantee the security of your data transmitted to the Platform; any transmission is at your own risk. Once we have received your information, we use strict procedures and security features to prevent unauthorised access to the best of our abilities.</p>
        
        <p> </p>
        
        <p>YOUR RIGHTS</p>
        
        <p>You are free to remove or delete content from your user account/profile and your account/ profile at any point in time. However, the history of your activities and account on our Platform remains available to us.</p>
        
        <p>You may correct, amend, add or delete Personal Information from your account at any time by logging in and visiting your profile page. As noted above, you may opt out from unwanted e-mail communications from us by following the instructions in the message. However, until your account is deleted you will continue to receive all system e-mails.</p>
        
        <p></p>
        
        <p>DATA RETENTION</p>
        
        <p></p>
        
        <p>We do not retain your Sensitive Personal Information (defined below in this paragraph) for longer than is required for the purposes for which the information may be lawfully used. For any other content, we will entertain your request for deletion, however, there is a strong possibility that copies of any public content will be retained indefinitely in our systems, including in cached and archived pages of the Platform, or if other users have copied or saved that information. In addition, due to the nature of the internet, copies of your content, including content that you have removed or deleted from your account, may also exist elsewhere on the Internet and be retained indefinitely. &ldquo;Sensitive Personal Information&rdquo; shall mean passwords and any other information that is classified as sensitive under Rule 3 of the Rules.</p>
        
        <p></p>
        
        <p>THIRD PARTY LINKS</p>
        
        <p></p>
        
        <p>The Platform may, from time to time, contain links to and from the websites of our partner networks, advertisers, Affiliates and/or any other websites or mobile applications. If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any responsibility or liability for these policies. Please check these policies before you submit any personal data to these websites or mobile applications.</p>
        
        <p></p>
        
        <p>MUSIC LABELS</p>
        
        <p></p>
        
        <p>By virtue of Talentino being a short-video platform, we have entered into music license agreements with various music labels in order to ensure optimal user experience on the Platform. Information pertaining to music data might be shared with such music labels from time to time in an anonymized manner.</p>
        
        <p></p>
        
        <p>THIRD-PARTY EMBEDS</p>
        
        <p> What Are Third Party Embeds?</p>
        
        <p></p>
        
        <p>Some of the content that you see displayed on the Platform is not hosted by the Platform. These &ldquo;embeds&rdquo; are hosted by a third-party and embedded in the Platform. For example: YouTube or Vimeo videos, Imgur or Giphy gifs, SoundCloud audio files, Twitter tweets, or Scribd documents that appear within a post on the Platform. These files send data to the hosted site just as if you were visiting that site directly (for example, when you load a Platform post page with a YouTube video embedded in it, YouTube receives data about your activity).</p>
        
        <p> Privacy Concerns with Third Party Embeds</p>
        
        <p></p>
        
        <p>The Platform does not control what data third parties collect or what they will do with it. So, third-party embeds on the Platform are not covered by this Privacy Policy. They are covered by the privacy policy of the third-party service.</p>
        
        <p> Sharing Personal Information with Third Party Embeds</p>
        
        <p></p>
        
        <p>Some embeds may ask you for Personal Information, such as your email address, through a form. We do our best to keep bad actors off the Platform. As explained above, their actions are not covered by this Privacy Policy. So, please be careful when you see embedded forms on the Platform asking for your email address or any other Personal Information. Make sure you understand who you are submitting your information to and what they say they plan to do with it. We suggest that you do not submit Personal Information to any third-party through an embedded form.</p>
        
        <p> Creating Your Own Third Party Embed</p>
        
        <p></p>
        
        <p>If you embed a form that allows submission of Personal Information by users, you must provide a prominent link to an applicable Privacy Policy next to the embedded form that clearly states how you intend to use any information collected. Failure to do so may lead the Company to disable the post or take other action to limit or disable your account.</p>
        
        <p></p>
        
        <p>COMMUNICATION FROM US</p>
        
        <p></p>
        
        <p>We may from time to time send you service-related announcements when we consider it necessary to do so (such as when we temporarily suspend the Platform for maintenance, or security, privacy, or administrative-related communications). We send these to you via SMS. You may not opt-out of these service-related announcements, which are not promotional in nature and used solely to protect your account and keep you informed of important changes to the Platform.</p>
        
        <p> GRIEVANCE OFFICER</p>
        
        <p></p>
        
        <p> Talentino has a Grievance Officer to address your concerns regarding data safety, privacy, and the Platform usage concerns. We will resolve the issues raised by you within 30 (thirty) days from receiving them. You may contact Mr. Shagun Baldwa, Grievance Officer at any of the following:</p>
        
        <p>Address: 8 Tadwadi , 4th Floor Chirabazar , Mumbai - 2</p>
        
        <p></p>`}}>



        </div>
    )
}
export default Privacy